import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

import { CheckboxItem } from './components/checkbox-item';

@NgModule({
  imports: [CheckboxItem, TranslatePipe],
  exports: [CheckboxItem, MatCheckboxModule, MatTooltipModule, TranslatePipe]
})
export class CelumCheckboxItemModule {}
